import React from 'react';
import { useLocation } from 'react-router-dom';
import StaticShell from '../Static/StaticShell';
import { regionFromPathname } from '../../utils/regionFromPath';
import { useI18n } from '../../hooks/useI18n';
import SEO from '../../components/seo/SEO';
import ManagedInlineBanner from '../../components/ads/ManagedInlineBanner';
import { bannerAds } from '../../data/staticAds';

export default function PrivacyPage() {
  const region = regionFromPathname(useLocation().pathname);
  const { t } = useI18n();
  return (
    <>
      <SEO
        region={region}
        path="/privacy"
        title={t('static.privacy.title', 'Privacy policy')}
        description={t('static.privacy.p1', 'How FliqMatch handles analytics, cookies and personal data.')}
      />
      <StaticShell title={t('static.privacy.title', 'Privacy policy')} region={region}>
        <>
          <p>{t('static.privacy.p1', 'We describe how FliqMatch handles analytics, cookies, and personal data.')}</p>
          <p style={{ marginTop: '1rem' }}>
            {t(
              'static.privacy.p2',
              'Where we show sponsored content, we may record ad impressions and clicks (including coarse location inferred from IP, device and browser hints, and which page or placement was shown). We use this for delivery measurement, reporting, and abuse prevention.',
            )}
          </p>
          <div style={{ marginTop: '2rem' }}>
            <ManagedInlineBanner pageKey="legal" fallbackAd={bannerAds[0]} variant="inline" />
          </div>
        </>
      </StaticShell>
    </>
  );
}
